export class Payment {
    public clientCode: string;
    public PaymentBillItemList: PendingBill[];
    public Currency : string;
    public Total: number;
    public CardTokenId: number;
  }
  export class PendingBill
  {
      public  Id: number;
      public  ClientCode : string;
      public  ClientName: string;
      public  Currency : string;
      public  CurrencySymbol: string;
      public dueDate: Date;
      public issueDate: Date;
      public numberDocument: string;
      public pendingDebt:number;
      public disabled : boolean;
      public checked : boolean;
  }
  export class Respuesta {
    public webService: string;
    public version: string;
    public applicationVersion: string;
    public status: string;
    public answer: any = new Answer();
    public ticket: string;
    public serverDate: Date;
    public applicationProvider: string;
    public metadata: string;
    public _type: string;
    
  }
  
  export class Answer {
    public formToken: string;
    public _type: string;
  }
  export class Customer {
    public email: string;
  }